import "@/App.css";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Compact } from "@/components/site/Compact";

function App() {
  return (
    <SmoothScroll>
      <div className="grain min-h-screen bg-[#050505] text-[#f3f4f6]">
        <Header />
        <main>
          <Hero />
          <Compact />
        </main>
      </div>
    </SmoothScroll>
  );
}

export default App;
